<template>
	<label class="el-check-input">
		<input
			type="checkbox"
			v-bind:checked="checked"
			v-on:change="$emit('change', $event.target.checked)"
		>
		<span class="checkmark"></span>

		<span class="label"> {{ label }} </span>

	</label>
</template>

<script>

export default {
	name: 'ElCheckInput',
	data() {
		return {
			checkInputValue: ''
		}
	},
	model: {
		prop: 'checked',
		event: 'change'
	},
	props: {
		label: {
			type: String,
			description: 'Label text',
		},
		checked: {
			type: Boolean,
			description: 'input value'
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/sass/variables";


.el-check-input {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	position: relative;
	cursor: pointer;
	user-select: none;
	margin: 2rem 0;

	/* Hide the browser's default checkbox */
	input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
		height: 0;
		width: 0;

		&:checked ~ .checkmark {
			background-color: #2196F3;
		}
		&:checked ~ .checkmark:after {
			display: block;
		}
	}

	/* Create a custom checkbox */
	.checkmark {
		position: relative;
		display: block;
		top: 0;
		left: 0;
		height: 32px;
		width: 32px;
		background-color: #eee;
		border-radius: 4px;
		flex-shrink: 0;

		&:after {
			content: "";
			position: absolute;
			display: none;

			left: 12px;
			top: 4px;
			width: 8px;
			height: 20px;
			border: solid white;
			border-width: 0 3px 3px 0;
			-webkit-transform: rotate(45deg);
			-ms-transform: rotate(45deg);
			transform: rotate(45deg);
		}
	}
	.label {
		padding-left: 10px;
	}

	&:hover input ~ .checkmark {
		background-color: #ccc;
	}
}

</style>
